import { useEffect, useLayoutEffect, useState } from "react"
import VisionMissionGoalComponent from "../components/VisionMissionGoalComponent"
import ActivitiesComponent from "../components/ActivitiesComponent"
import FormComponent from "../components/FormComponent"
import Header from "../components/Header"
import UpcomingEvent from "../components/UpComingEvent"
import PatnerComponent from "../components/PatnerComponent"



const HomePage = () => {

    const [loading, setIsLoading] = useState(false)

    useLayoutEffect(() => {
        setIsLoading(true)
        console.log('loading...')


        return () => {
        }
   
    }, [])


    useEffect(() => {
        setIsLoading(false)
        console.log('Home page is running...')


        return () => {
            console.log('done...')
        }
    }, [])

    if (loading) <>
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75">

        </span>
    </>


    return (
        <>

            {/* <VisionMissionGoalComponent />

            <ActivitiesComponent />

            <FormComponent />
 */}

            <Header type="home"></Header>

            <VisionMissionGoalComponent />

            <ActivitiesComponent />

            <FormComponent
                title="Become a volunter"
                type='home'
                divVolunter="text-[25px] font-bold mb-5 text-[#ffa809]"
                divContainer="h-[500px] flex m-auto py-20 w-[90%] justify-evenly my-16"
                input="bg-opacity-5 bg-white mr-4 mb-4 p-2 border-solid border-2 border-[#ffa809]"
                textArea="bg-opacity-5 w-[420px] bg-white p-2 border-solid border-2 border-[#ffa809]"
                button="bg-[#ffa809] w-24  h-10 flex items-center justify-center mt-10 text-white"
            />
            <UpcomingEvent />


            <PatnerComponent />


        </>
    )
}

export default HomePage